import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { fmtCurrency, fmtDate } from './helpers';

const AgingTab = ({ agingLoading, aging }) => {
  return (
    <>
      {agingLoading && <div className="flex items-center justify-center h-40"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600"></div></div>}
      {aging && !agingLoading && (
        <>
          {/* Aging Buckets Summary */}
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
            {[
              { key: '0_30', color: 'emerald' },
              { key: '31_60', color: 'yellow' },
              { key: '61_90', color: 'orange' },
              { key: '90_plus', color: 'red' },
            ].map(({ key, color }) => {
              const bucket = aging.buckets[key];
              return (
                <Card key={key} className={`border-${color}-200`}>
                  <CardContent className="p-4 text-center">
                    <p className="text-xs text-gray-500 font-medium">{bucket.label}</p>
                    <p className={`text-lg font-bold text-${color}-700`}>{fmtCurrency(bucket.total)}</p>
                    <p className="text-[10px] text-gray-400">{bucket.entries.length} bills</p>
                  </CardContent>
                </Card>
              );
            })}
            <Card className="border-2 border-gray-400 bg-gray-50">
              <CardContent className="p-4 text-center">
                <p className="text-xs text-gray-500 font-medium">Total Unpaid</p>
                <p className="text-lg font-bold text-gray-800">{fmtCurrency(aging.total_unpaid)}</p>
              </CardContent>
            </Card>
          </div>

          {/* Aging Detail Tables */}
          {['0_30', '31_60', '61_90', '90_plus'].map(key => {
            const bucket = aging.buckets[key];
            if (bucket.entries.length === 0) return null;
            const colorMap = { '0_30': 'emerald', '31_60': 'yellow', '61_90': 'orange', '90_plus': 'red' };
            const c = colorMap[key];
            return (
              <Card key={key}>
                <CardContent className="p-0">
                  <div className={`px-4 py-2 bg-${c}-50 border-b border-${c}-200 flex items-center justify-between`}>
                    <span className={`text-sm font-semibold text-${c}-800`}>{bucket.label}</span>
                    <span className={`text-sm font-bold text-${c}-700`}>{fmtCurrency(bucket.total)}</span>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm" data-testid={`aging-table-${key}`}>
                      <thead><tr className="bg-gray-50 border-b">
                        <th className="px-3 py-2 text-center font-medium w-[50px]">Type</th>
                        <th className="px-3 py-2 text-left font-medium">Ref #</th>
                        <th className="px-3 py-2 text-left font-medium">Customer</th>
                        <th className="px-3 py-2 text-left font-medium">Date</th>
                        <th className="px-3 py-2 text-right font-medium">Amount</th>
                        <th className="px-3 py-2 text-right font-medium">Commission</th>
                        <th className="px-3 py-2 text-center font-medium">Days</th>
                      </tr></thead>
                      <tbody>
                        {bucket.entries.map((e, i) => (
                          <tr key={i} className="border-b border-gray-100">
                            <td className="px-3 py-2 text-center"><Badge className={`text-[9px] ${e.type === 'SE' ? 'bg-blue-100 text-blue-700' : 'bg-red-100 text-red-700'}`}>{e.type}</Badge></td>
                            <td className="px-3 py-2 font-mono text-xs">{e.ref}</td>
                            <td className="px-3 py-2 text-xs text-gray-600">{e.customer}</td>
                            <td className="px-3 py-2 text-xs">{fmtDate(e.date)}</td>
                            <td className="px-3 py-2 text-right text-xs">{fmtCurrency(e.amount)}</td>
                            <td className={`px-3 py-2 text-right font-medium ${e.commission < 0 ? 'text-red-600' : 'text-indigo-700'}`}>{fmtCurrency(Math.abs(e.commission))}{e.commission < 0 ? ' (CR)' : ''}</td>
                            <td className="px-3 py-2 text-center">
                              <span className={`text-xs font-medium px-1.5 py-0.5 rounded ${e.days > 90 ? 'bg-red-100 text-red-700' : e.days > 60 ? 'bg-orange-100 text-orange-700' : e.days > 30 ? 'bg-yellow-100 text-yellow-700' : 'bg-green-100 text-green-700'}`}>
                                {e.days}d
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </>
      )}
    </>
  );
};

export default AgingTab;
